import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import { useWidgetTaskSingleSections_widgetTaskSingle$key } from "./__generated__/useWidgetTaskSingleSections_widgetTaskSingle.graphql";

export function useWidgetSections(
  widgetKey: useWidgetTaskSingleSections_widgetTaskSingle$key,
  clientFilterIds?: string[]
) {
  const widget = useFragment(
    graphql`
      fragment useWidgetTaskSingleSections_widgetTaskSingle on WidgetTaskSingle {
        activeSectionVersions {
          id
          title
          ordinal
          section {
            id
            assignedTeam {
              id
              name
              color
              icon
            }
          }
        }
      }
    `,
    widgetKey
  );

  const sections = useMemo(() => {
    const activeVersions = widget.activeSectionVersions.map(
      (sectionVersion) => ({
        id: sectionVersion.section.id,
        title:
          (sectionVersion.title === null || sectionVersion.title === ""
            ? sectionVersion.section.assignedTeam?.name
            : sectionVersion.title) ?? "",
        ordinal: sectionVersion.ordinal,
        assignedTeam: sectionVersion.section.assignedTeam ?? undefined,
      })
    );
    if (clientFilterIds) {
      return activeVersions.filter((section) =>
        clientFilterIds.includes(section.id)
      );
    }
    return activeVersions;
  }, [clientFilterIds, widget.activeSectionVersions]);

  return sections;
}
export type Section = ReturnType<typeof useWidgetSections>[number];
